import styled, { css } from 'styled-components';

export const FeedbackContainer = styled.button`
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  position: absolute;
  right: 0;
`;

export const FeedbackIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 5px;
  pointer-events: none;
`;

export const LessonCompleteContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5em;
  border-top: 1px solid #091e4214;
  cursor: pointer;
  box-shadow: #091e4240 0px 1px 1px, #091e424f 0px 0;
  background-color: #ffffff;
  border: 1px solid #f1f1f1;
  border-radius: 0.5em;
  margin: 1em 0.125em 0.75em;
  overflow: hidden;
`;

export const LessonCompleteStatus = styled.span`
  background: ${(props) => props.theme.colorStyled.ColorBgAvartar};
  font-size: ${(props) => props.theme.fontSize.PrimaryFontSize};
  border-radius: 100%;
  width: 1.75em;
  height: 1.75em;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 300ms ease;
  cursor: pointer;
  ${({ isCompleted }) =>
    isCompleted &&
    css`
      background: ${(props) => props.theme.colorStyled.ColorActiveCheckbox};
      color: ${(props) => props.theme.colorStyled.ColorWhite};
    `}

  @media (max-width: 360px) {
    align-self: flex-end;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-transform: uppercase;
  margin-bottom: 1em;
  i {
    font-size: ${(props) => props.theme.fontSize.HeadingH4FontSize};
    margin-right: 0.5em;
    color: ${(props) => props.theme.colorStyled.ColorTime};
  }
  color: ${(props) => props.theme.colorStyled.ColorTextOrange};
  justify-content: center;
  text-transform: none;
  font-size: 16px;
`;

export const ModalContent = styled.div`
  line-height: 20px;
  color: #6e6e6e;
  text-align: center;
  > i {
    position: absolute;
    right: 1.5em;
    top: 2em;
  }
`;

export const ModalGroupAction = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  justify-content: center;
  margin-top: 1.25em;
  button {
    margin-left: 0.5em;
    text-align: center;
    border-radius: 0.325em;
    border-radius: 7px;
    font-family: 'MontserratSemiBold';
    cursor: pointer;
    border: none;
    color: #ffffff;
    width: 6em;
    height: 2.5em;
    font-size: ${(props) => props.theme.fontSize.PrimaryFontSize};
    &:first-child {
      background-color: ${(props) => props.theme.colorStyled.ColorPrimaryBlue};
      background-color: unset;
      color: ${(props) => props.theme.colorStyled.ColorPrimaryBlue};
      width: fit-content;
      border: 1px solid ${(props) => props.theme.colorStyled.ColorPrimaryBlue};
    }
    margin: 0 0.5em;
    background-color: #4786fd;
    padding: 1px 15px;
  }
  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const AudioNarrationWrap = styled.div`
  margin-bottom: 0.75em;
  padding-bottom: 0.75em;
  border-bottom: 1px solid ${(props) => props.theme.colorStyled.ColorBorderInput};
`;

export const AudioNarrationLabel = styled.span`
  display: block;
  margin-bottom: 0.5em;
  font-size: 12px;
  font-family: 'MontserratSemiBold', sans-serif;
  color: ${(props) => props.theme.colorStyled.ColorTime};
`;

export const AudioNarrationPills = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5em;
`;

export const AudioNarrationPill = styled.button`
  padding: 0.35em 0.75em;
  border-radius: 1em;
  border: 1px solid
    ${(props) =>
      props.$isActive
        ? props.theme.colorStyled.ColorPrimaryBlue
        : props.theme.colorStyled.ColorBorderInput};
  background-color: ${(props) =>
    props.$isActive ? props.theme.colorStyled.ColorPrimaryBlue : 'transparent'};
  color: ${(props) =>
    props.$isActive
      ? props.theme.colorStyled.ColorWhite
      : props.theme.colorStyled.ColorBlack};
  font-size: 12px;
  font-family: 'MontserratMedium', sans-serif;
  cursor: pointer;
  transition: background-color 200ms ease, color 200ms ease, border-color 200ms ease;

  &:hover {
    border-color: ${(props) => props.theme.colorStyled.ColorPrimaryBlue};
    color: ${(props) =>
      props.$isActive
        ? props.theme.colorStyled.ColorWhite
        : props.theme.colorStyled.ColorPrimaryBlue};
  }
`;

export const SubLessonSlidesCard = styled.div`
  box-shadow: #091e4240 0px 1px 1px, #091e424f 0px 0;
  background-color: ${(props) => props.theme.colorStyled.ColorWhite};
  border: 1px solid #f1f1f1;
  border-radius: 0.5em;
  margin: 0.125em 0.125em 0.75em;
  overflow: hidden;
`;

export const SubLessonSlidesHeader = styled.div`
  padding: 0.875em 0.75em 0.625em;
  border-bottom: 1px solid ${(props) => props.theme.colorStyled.ColorBorderInput};
`;

export const SubLessonSlidesHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5em;
`;

export const SubLessonSlidesTitle = styled.h3`
  margin: 0;
  font-size: 14px;
  font-family: 'MontserratSemiBold', sans-serif;
  color: ${(props) => props.theme.colorStyled.ColorBlack};
`;

export const SubLessonSlidesCount = styled.span`
  flex-shrink: 0;
  font-size: 12px;
  font-family: 'MontserratSemiBold', sans-serif;
  color: ${(props) => props.theme.colorStyled.ColorPrimaryBlue};
  background-color: ${(props) => props.theme.colorStyled.ColorPrimaryBlue}14;
  border-radius: 1em;
  padding: 0.15em 0.6em;
`;

export const SubLessonSlidesHint = styled.p`
  margin: 0.35em 0 0;
  font-size: 12px;
  color: ${(props) => props.theme.colorStyled.ColorTime};
  line-height: 1.4;
`;

export const SubLessonSlidesList = styled.div``;

export const SubLessonListItem = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.75em;
  border: none;
  border-top: 1px solid ${(props) => props.theme.colorStyled.ColorBorderInput};
  background-color: ${(props) =>
    props.$isActive ? `${props.theme.colorStyled.ColorPrimaryBlue}0d` : 'transparent'};
  border-left: 3px solid
    ${(props) =>
      props.$isActive ? props.theme.colorStyled.ColorPrimaryBlue : 'transparent'};
  cursor: pointer;
  text-align: left;
  transition: background-color 200ms ease;

  &:hover {
    background-color: ${(props) => props.theme.colorStyled.ColorBgSeashell};
  }

  &:first-child {
    border-top: none;
  }
`;

export const SubLessonNumber = styled.span`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5em;
  height: 1.5em;
  margin-right: 0.5em;
  border-radius: 100%;
  font-size: 12px;
  font-family: 'MontserratSemiBold', sans-serif;
  color: ${(props) =>
    props.$isActive
      ? props.theme.colorStyled.ColorWhite
      : props.theme.colorStyled.ColorPrimaryBlue};
  background-color: ${(props) =>
    props.$isActive
      ? props.theme.colorStyled.ColorPrimaryBlue
      : `${props.theme.colorStyled.ColorPrimaryBlue}18`};
`;

export const SubLessonNextPartButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5em;
  width: 100%;
  margin-top: 0.75em;
  padding: 0.75em 1em;
  border: none;
  border-radius: 0.5em;
  background-color: ${(props) => props.theme.colorStyled.ColorPrimaryBlue};
  color: ${(props) => props.theme.colorStyled.ColorWhite};
  font-size: 14px;
  font-family: 'MontserratSemiBold', sans-serif;
  cursor: pointer;
  box-shadow: #091e4240 0px 1px 2px;
  transition: background-color 200ms ease, box-shadow 200ms ease;

  &:hover {
    background-color: ${(props) =>
      props.theme.colorStyled.ColorPrimaryBlueHover ||
      props.theme.colorStyled.ColorPrimaryBlue};
    box-shadow: #091e4240 0px 2px 4px;
  }

  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.colorStyled.ColorPrimaryBlue};
    outline-offset: 2px;
  }

  i {
    font-size: 0.9em;
  }
`;
